/* Different Drips — blog post: reading progress bar, TOC active state, copy-link button */
(() => {
  const body = document.querySelector('[data-article-body]');
  if (!body) return;

  // Reading progress across the article body
  const bar = document.querySelector('.dd-progress__bar');
  if (bar) {
    let ticking = false;
    const update = () => {
      const r = body.getBoundingClientRect();
      const total = r.height - window.innerHeight * 0.6;
      const done = Math.min(1, Math.max(0, -r.top / Math.max(total, 1)));
      bar.style.transform = `scaleX(${done})`;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // Highlight the TOC entry for the section in view
  const toc = document.querySelector('[data-toc]');
  if (toc && 'IntersectionObserver' in window) {
    const links = new Map();
    toc.querySelectorAll('a[href^="#"]').forEach((a) => {
      const el = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (el) links.set(el, a);
    });
    const setActive = (a) => {
      toc.querySelectorAll('a.is-active').forEach((x) => x.classList.remove('is-active'));
      if (a) a.classList.add('is-active');
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) setActive(links.get(e.target)); });
    }, { rootMargin: '-15% 0px -70% 0px' });
    links.forEach((_, el) => io.observe(el));
  }

  // Close the mobile TOC after a jump
  document.querySelectorAll('.dd-toc--mobile a').forEach((a) => {
    a.addEventListener('click', () => a.closest('details')?.removeAttribute('open'));
  });

  document.querySelectorAll('[data-copy-link]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(btn.dataset.copyLink);
        const label = btn.textContent;
        btn.textContent = 'Copied';
        setTimeout(() => { btn.textContent = label; }, 1600);
      } catch (e) { /* clipboard blocked; nothing to do */ }
    });
  });
})();
